import { render, staticRenderFns } from "./EurListServiceAndSupport.vue?vue&type=template&id=54f5032f"
import script from "./EurListServiceAndSupport.vue?vue&type=script&lang=js"
export * from "./EurListServiceAndSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports